import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ViewCmDetails({
  open,
  handleClose,
}) {

  const icaState = (state) => state.inCampActivityReducer;
  
  const { cmIca } = useSelector(icaState);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle style={{ textAlign: "center", fontWeight: "bold" }}>
        In-camp Corp Members Details
        <IconButton onClick={handleClose} sx={{ position: "absolute", right: 0, top: 0 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Name"
              variant="outlined"
              fullWidth
              value={cmIca?.cmName ?? ''}
              readOnly
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Callup"
              variant="outlined"
              fullWidth
              value={cmIca?.callUpNo ?? ''}
              readOnly
            />
          </Grid>
           <Grid item xs={6}>
            <TextField
              label="State code"
              variant="outlined"
              fullWidth
              value={cmIca?.stateCode ?? ''}
              readOnly
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Batch"
              variant="outlined"
              fullWidth
              value={cmIca?.batch ?? ''}
              readOnly
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Phone Number"
              variant="outlined"
              fullWidth
              value={cmIca?.phoneNumber ?? ''}
              readOnly
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Gender"
              variant="outlined"
              fullWidth
              value={cmIca?.gender ?? ''}
              readOnly
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Skill"
              variant="outlined"
              fullWidth
              value={cmIca?.skill ?? ''}
              readOnly
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Subskill"
              variant="outlined"
              fullWidth
              value={cmIca?.subSkill ?? ''}
              readOnly
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
      </DialogActions>
    </Dialog>
  );
}
